import { render, staticRenderFns } from "./realtimeList.vue?vue&type=template&id=1bc025dc&scoped=true"
import script from "./realtimeList.vue?vue&type=script&lang=js"
export * from "./realtimeList.vue?vue&type=script&lang=js"
import style0 from "./realtimeList.vue?vue&type=style&index=0&id=1bc025dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc025dc",
  null
  
)

export default component.exports